// extracted by mini-css-extract-plugin
export default {"row":"AdditionalForm_row__aiZci","fieldSet":"AdditionalForm_fieldSet__7HRPT","legend":"AdditionalForm_legend__Qatxu","placeHolderShimmer":"AdditionalForm_placeHolderShimmer__RcE4K"};